import React, {useRef, useState} from "react";
import "./UploadImageFile.scss"
import {FileManagerService} from "../../../component/fileManager/FileManagerService";
import {css} from "@emotion/css";
import {LinearProgress} from "@mui/material";
import {
    RaikoAlert,
    raikoAlertTypes,
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    showErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function UploadImageFile(
    {
        uploadUrl,
        handleRefreshList
    }
) {

    const service = new FileManagerService()

    const [showUploadLoading, setShowUploadLoading] = useState(false)

    const [uploadPercent, setUploadPercent] = useState(0);
    const [imageFile, setImageFile] = useState();

    const [imageFileName, setImageFileName] = useState("")

    const uploadPhotoFile = useRef();

    function uploadImageFile({target: {files}}) {

        if (typeof files[0] !== 'undefined') {
            setImageFile(files[0])
            setImageFileName(files[0].name)
        }

    }

    function handleSelectImageFile() {
        uploadPhotoFile.current.click()
    }

    function handleHideLoading() {
        setUploadPercent(0)
    }

    function handleUploadImage() {
        setShowUploadLoading(true)

        service.uploadImageFile(
            imageFile,
            handleHideLoading,
            setUploadPercent,
            uploadUrl
        ).then(response => {
            showSuccessMessage("عکس جدید با موفقیت بارگزاری شد.")
            setImageFileName("")
            setImageFile(null)
            handleRefreshList(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setShowUploadLoading(false)
        })
    }

    return (
        <div className={"baseUploadImageFileContainer"}>

            {
                imageFile ?
                    <RaikoGridOneColumn>
                        <img src={URL.createObjectURL(imageFile)} alt={imageFileName}
                             className={"selectedImagePreview"}/>
                    </RaikoGridOneColumn> :
                    <RaikoAlert
                        type={raikoAlertTypes.info}
                        title={"بارگزاری تصویر جدید"}
                        description={[
                            "* تنها فرمت قابل پذیرش jpeg و jpg می باشد.",
                            "",
                        ]}
                        className={css`width: 100%`}
                    />
            }

            {
                showUploadLoading ?
                    <div className={`loadingContainer ${css`width: 100%;`}`}>
                        <div className={css`
                          display: grid;
                          gap: .75rem;`
                        }>
                            <span className={"loadingHintTitle"}> ({uploadPercent + "%"}) در حال بارگزاری تصویر جدید، لطفا صبور باشید...</span>
                            <LinearProgress
                                hidden={false}
                                variant="buffer"
                                value={uploadPercent}
                                valueBuffer={0}
                            />
                        </div>

                    </div> : ""
            }

            <input
                ref={uploadPhotoFile}
                type="file"
                hidden
                accept="image/png,image/gif,image/jpeg"
                onChange={uploadImageFile}/>

            <RaikoFlexAlignEnd className={css`gap: .5rem`}>
                {
                    imageFile &&
                    <RaikoButtonSecondary
                        label={"انتخاب تصویر"}
                        onClick={handleSelectImageFile}
                    />
                }
                {
                    imageFile &&
                    <RaikoButtonPrimary
                        label={"بارگزاری تصویر"}
                        onClick={handleUploadImage}
                    />
                }
                {
                    !imageFile &&
                    <RaikoButtonPrimary
                        label={"انتخاب تصویر"}
                        onClick={handleSelectImageFile}
                    />
                }
            </RaikoFlexAlignEnd>
        </div>
    )
}
